// extracted by mini-css-extract-plugin
export default {"lineButtons":"otherPropertyItemNew_lineButtons__xNnCG","headers":"otherPropertyItemNew_headers__UMElU","semiTitle":"otherPropertyItemNew_semiTitle__21OkM"};